import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const getAdminUsers = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.AdminUser?.api + '?page=' + page + '&pageSize=' + (data?.pageSize ? data?.pageSize : '') + '&search=' + (data?.search ? data?.search : '')}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addAdminUserApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.AdminUser.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateAdminUserApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.AdminUser.api + '/' + data.id}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
